export const LOGO_URL = '/logo.svg';

export const SUPPORT_EMAIL = 'help@gocascade.ai';

export const PRIVACY_POLICY_URL = 'https://www.gocascade.ai/privacy-policy';

export const TERMS_OF_SERVICE_URL =
  'https://www.gocascade.ai/terms-and-conditions';

export const LOGO_SYMBOL_URL = '/logo-symbol.svg';

export const LOGO_SMALL_URL = '/logo-small.svg';

export const AGENT_AVATAR_URL = '/agent-avatar.png';

export const APP_ICON_URL = '/icons/icon-192.png';
